module.exports = __webpack_public_path__ + "static/media/blusa-feminina.8b9282a7.jpg";